import React, { type FC } from 'react';

import type { BytescaleImageProps } from './BytescaleImage.types';

// TODO: Move to env variables
const DEFAULT_BYTESCALE_ACCOUNT_ID = '12a1yC2';

/**
 * Generates a Bytescale-optimized image URL
 */
const getBytescaleImageURL = (
  path: string,
  width: number | undefined,
  height: number | undefined,
  accountId: string
): string => {
  const params = new URLSearchParams();

  if (width) params.append('w', width.toString());
  if (height) params.append('h', height.toString());

  // Auto format, cache optimization
  params.append('f', 'auto');
  params.append('cache_perm', 'auto');
  params.append('cache_ttl', '31536000'); // 1 year

  return `https://upcdn.io/${accountId}/image${path}?${params.toString()}`;
};

/**
 * BytescaleImage - Optimized image component with Bytescale CDN integration
 *
 * Displays images from Bytescale storage with automatic optimization,
 * caching, and format conversion.
 */
export const BytescaleImage: FC<BytescaleImageProps> = ({
  imagePath,
  width,
  height,
  alt,
  className,
  accountId = DEFAULT_BYTESCALE_ACCOUNT_ID,
  ...props
}) => {
  if (!imagePath) {
    return null;
  }

  const url = getBytescaleImageURL(imagePath, width, height, accountId);
  const basename = imagePath.split('/').reverse()[0];
  const altText = alt || basename;

  return (
    <img
      src={url}
      alt={altText}
      width={width}
      height={height}
      className={className}
      {...props}
    />
  );
};
